import { List, EditButton, ShowButton, SimpleList, CreateButton, TopToolbar, TextInput } from "react-admin";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { EMPLOYEES, MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import EmployeeTable from "./components/EmployeeTable";

const ListEmployees = () => {
  const userPermissions = getPermissions();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const employeeFilters = [
    <TextInput
      label="Име"
      source="firstName"
      alwaysOn
    />,
    <TextInput
      label="Фамилия"
      source="lastName"
      alwaysOn
    />,
    <TextInput
      label="Имейл"
      source="email"
      alwaysOn
    />,
  ];
  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={AdministrationExporter(EMPLOYEES)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Служители на университета"
      filters={employeeFilters}
      actions={ListActions(checkPermission(userPermissions, permissions.canCreateEmployees))}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                {
                  label: "Име",
                  value: `${record?.firstDegreeNameBgShort || ""} ${record?.firstName || ""} ${
                    record?.secondName || ""
                  } ${record?.lastName || ""}`,
                },
              ]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Имейл", value: record?.email || "-" }]} />
              <MobileListRow fields={[{ value: !record?.isActive ? "Неактивен" : "" }]} />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateEmployees) && <EditButton label="" />}
              {checkPermission(userPermissions, permissions.canPreviewEmployees) && <ShowButton label="" />}
            </>
          )}
        />
      ) : (
        <EmployeeTable />
      )}
    </List>
  );
};

export default ListEmployees;
